export default __webpack_public_path__ + "static/media/sg.340862b8.svg";